import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface StrategicSummaryForm {
    [key: string]: SingleDynamicField[];
}

export const useStrategicSummary = (chatAssistant: ChatAssistant) => {
    const formikStrategicSummary = useFormik<StrategicSummaryForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikStrategicSummary.setValues({
                strategicSummary:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.strategicSummary ?? initialValues.strategicSummary,
            });
        }
    }, [chatAssistant]);

    return { formikStrategicSummary };
};
